// extracted by mini-css-extract-plugin
module.exports = {"photoArrowNavWrapper":"PhotoArrowNav_photoArrowNavWrapper__1b8Gg","arrowWrapper":"PhotoArrowNav_arrowWrapper__34sMK","right":"PhotoArrowNav_right__2NB7k"};